import moment from 'moment'
export default {
  setTempParam (param) {
    window.temporaryParam = param
  },
  getTempParam () {
    return window.temporaryParam
  },
  delayBack () {
    setTimeout(() => {
      $router.back()
    }, 1000)
  },
  formatTime (time) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss')
  },
  formatDateByDate (date) {
    return moment(date).format('YYYY-MM-DD')
  },
  startOfADay (date) {
    return moment(date).startOf('day').toDate().getTime()
  },
  datePlusOneDay (date) {
    return moment(date).add(1, 'day').toDate()
  },
  dateMinusOneDay (date) {
    return moment(date).add(-1, 'day').toDate()
  },
  getMonthlyRange (startNum, endNum) { // start: -2, end 0,相当于2个月前到这个月底,总共三个月的时间
    if ((typeof startNum !== 'number') || (typeof endNum !== 'number')) {
      return undefined
    }
    let startTime = moment(new Date()).add(startNum, 'month')
    let endTime = moment(new Date()).add(endNum, 'month')
    let start = startTime.startOf('month')
    let end = endTime.endOf('month')
    return {
      start: Date.parse(start),
      end: Date.parse(end)
    }
  },
  setTitle (title) {
    document.getElementsByTagName('title')[0].innerHTML = title
  },
  formatPrice (number, companyId) {
    if (companyId == 198) {
      return '券' + parseFloat(number / 100).toFixed(1) + '张'
    } else {
      return parseFloat(number / 100).toFixed(1) + ''
    }
  },
  formatPriceNumber (number) {
    return parseFloat(number / 100).toFixed(1)
  },
  checkTimeReached (timeStamp) {
    let now = new Date().getTime()
    return timeStamp > 0 ? (now > timeStamp) : false
  },
  showLoading (text) {
    window.$app.$emit('loading', text)
  },
  hideLoading () {
    window.$app.$emit('loading', null)
  },
  showToast (message, style, autoCancel = true) {
    window.$app.$emit('toast', message, autoCancel)
  },
  hideToast () {},
  /*
   * eg. data.a.b.c -> data: data, props: ['a', 'b', 'c']
   * @param {Object} data to be check
   * @param {String, Array} props a
   * @return  { Boolean } result
   */
  hasPropertyDeep (data, props) {
    if (!(data instanceof Object)) {
      return false
    }
    if (typeof props === 'string') {
      return data[props] !== null && data[props] !== undefined
    }
    if (!(props instanceof Array)) {
      return false
    }
    let curData = data
    for (let i = 0; i < props.length; i++) {
      curData = curData[props[i]]
      if (i === (props.length - 1)) {
        return curData !== null && curData !== undefined
      }
      if (!(curData instanceof Object)) {
        return false
      }
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js